import { Button } from "antd";
import type { ColumnsType } from "antd/es/table";
import { FormConfigType } from "../../../components/editForm";
import { langPage, langCommon, langTableColumns } from "../../../locales";

const langRecharge = langPage?.amount;
const lang = langPage?.amount?.recharge;
export const DEFAULT_QUERY_DATA = {
    FromMemberEmail: "",
    ToMemberEmail: null,
    DateEnd: null,
    DateStart: null,
    CreatedAt: null,
}

export const generateQueryFormConfig = (): FormConfigType => {
    return [
        {
            title: "转出用户邮箱",
            type: "input",
            field: "FromMemberEmail",
            allowClear: true,
        },
        {
            title: "转入用户邮箱",
            type: "input",
            field: "ToMemberEmail",
            allowClear: true,
        },
        {
            title: "日期",
            type: "rangePicker",
            field: "CreatedAt",
            fields: ['DateStart', 'DateEnd'],
            allowClear: true,
        },
    ];
}

export const generateTableColumns = (): ColumnsType => {
    return [
        {
            title: "id",
            dataIndex: "Id",
        },
        {
            title: "订单号",
            dataIndex: "OrderNo",
        },
        {
            title: "转出用户id",
            dataIndex: "FromMemberId",
        },
        {
            title: "转出用户邮箱",
            dataIndex: "FromMember",
            render(value, record, index) {
                return value?.Email
            },
        },
        {
            title: "转入用户id",
            dataIndex: "ToMemberId",
        },
        {
            title: "转入用户邮箱",
            dataIndex: "ToMember",
            render(value, record, index) {
                return value?.Email
            },
        },
        {
            title: "实际转账到账",
            dataIndex: "ReceivedAmount",
        },
        {
            title: "日期",
            dataIndex: "Daily",
        },
        {
            title: "创建时间",
            dataIndex: "CreatedAtString",
        },
    ]
}